import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import Layer from "./..";
import * as React from 'react';
import Rect from "../Rect";
import classNames from 'classnames';
import calculateAutoflip from "./calculateAutoflip";
import calculateContextPoint from "./calculateContextPoint";
import elementContains from "../elementContains";
import getViewportHeight from "../getViewportHeight";
import getViewportWidth from "../getViewportWidth";

function hasAncestor(el, cls) {
  var element = el;

  while (element && !element.classList.contains(cls)) {
    element = element.parentElement;
  }

  return !!element;
}

var ContextualLayer = /*#__PURE__*/function (_React$Component) {
  _inherits(ContextualLayer, _React$Component);

  var _super = _createSuper(ContextualLayer);

  function ContextualLayer(props) {
    var _this;

    _classCallCheck(this, ContextualLayer);

    _this = _super.call(this, props);
    _this.ref = void 0;

    _this.childRef = function (node) {
      _this.ref = node;
    };

    _this.handleScroll = function (e) {
      var target = e.target;
      var _this$props = _this.props,
          context = _this$props.context,
          onScroll = _this$props.onScroll;
      var element = context.element;

      if (target instanceof Node && elementContains(target, element) && (!onScroll || onScroll(e) !== 'handled')) {
        requestAnimationFrame(function () {
          return _this.calculate();
        });
      }
    };

    _this.handleResizeWindow = function (e) {
      var onResizeWindow = _this.props.onResizeWindow;

      if (!onResizeWindow || !onResizeWindow(e) !== 'handled') {
        requestAnimationFrame(function () {
          return _this.calculate();
        });
      }
    };

    _this.state = {
      childStyle: null,
      contextPoint: null,
      meetingPointClasses: _this.getMeetingPointClasses(props.contextMeetingPoint, props.layerMeetingPoint)
    };
    return _this;
  }

  _createClass(ContextualLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.calculate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.children !== this.props.children || prevProps.context.element !== this.props.context.element || prevProps.context.rect !== this.props.context.rect || prevProps.contextMeetingPoint !== this.props.contextMeetingPoint || prevProps.layerMeetingPoint !== this.props.layerMeetingPoint || prevProps.offsetX !== this.props.offsetX || prevProps.offsetY !== this.props.offsetY) {
        this.calculate();
      }
    }
  }, {
    key: "calculate",
    value: function calculate() {
      var _this2 = this;

      var node = this.ref;

      if (!node) {
        return;
      }

      var _this$props2 = this.props,
          adjustOffsets = _this$props2.adjustOffsets,
          adjustMeetingPoints = _this$props2.adjustMeetingPoints,
          autoflip = _this$props2.autoflip,
          context = _this$props2.context,
          flipAxis = _this$props2.flipAxis,
          givenOffsetX = _this$props2.offsetX,
          givenOffsetY = _this$props2.offsetY,
          onCalculate = _this$props2.onCalculate,
          variableWidth = _this$props2.variableWidth;
      var _this$props3 = this.props,
          contextMeetingPoint = _this$props3.contextMeetingPoint,
          layerMeetingPoint = _this$props3.layerMeetingPoint;
      var offsetX = givenOffsetX || 0;
      var offsetY = givenOffsetY || 0;
      var layerRect = Rect.fromClientRect(node.getBoundingClientRect(), 'document');
      var element = context.element,
          rect = context.rect;
      var contextClientRect = rect || element.getBoundingClientRect();

      if (autoflip && autoflip !== 'none') {
        var autoflipBehavior = typeof autoflip === 'boolean' ? 'both' : autoflip;

        var _calculateAutoflip = calculateAutoflip({
          autoflipBehavior: autoflipBehavior,
          contextClientRect: contextClientRect,
          contextMeetingPoint: contextMeetingPoint,
          flipAxis: flipAxis || 'context-center',
          // Flow types for these props aren't great
          layerRect: layerRect,
          layerMeetingPoint: layerMeetingPoint,
          offsetY: offsetY,
          offsetX: offsetX
        }),
            flippedContextPoint = _calculateAutoflip.contextMeetingPoint,
            flippedLayerPoint = _calculateAutoflip.layerMeetingPoint;

        contextMeetingPoint = flippedContextPoint;
        layerMeetingPoint = flippedLayerPoint;
      }

      if (adjustMeetingPoints) {
        var adjusted = adjustMeetingPoints(contextMeetingPoint, layerMeetingPoint);
        contextMeetingPoint = adjusted.context;
        layerMeetingPoint = adjusted.layer;
      }

      if (adjustOffsets) {
        var _adjusted = adjustOffsets(contextMeetingPoint, layerMeetingPoint, offsetX, offsetY);

        offsetX = _adjusted.x;
        offsetY = _adjusted.y;
      }

      var contextRect = Rect.fromClientRect(contextClientRect, 'document');
      var contextPoint = calculateContextPoint({
        contextRect: contextRect,
        contextMeetingPoint: contextMeetingPoint,
        layerRect: layerRect,
        layerMeetingPoint: layerMeetingPoint,
        offsetX: offsetX,
        offsetY: offsetY
      });
      this.setState({
        childStyle: this.childStyle(layerMeetingPoint, contextPoint, layerRect, variableWidth),
        contextPoint: contextPoint,
        meetingPointClasses: this.getMeetingPointClasses(contextMeetingPoint, layerMeetingPoint)
      }, function () {
        var contextPoint = _this2.state.contextPoint; // trigger an event with the offsets and size of the layer

        if (onCalculate && contextPoint) {
          // get the top and left offsets of the contextPoint of the layer
          var top = contextPoint.y,
              left = contextPoint.x; // get the dimensions of the layer

          var width = layerRect.width,
              height = layerRect.height; // Adding all the properties necessary for a Rect

          onCalculate(new Rect({
            top: top,
            left: left,
            right: left + width,
            bottom: top + height,
            width: width,
            height: height
          }, 'document'));
        }
      });
    }
    /**
     * If a scroll event occurs on a target element that contains the context
     * element, allow the caller to handle the event, e.g. to hide the layer.
     * If no handler is specified or the event is not handled by the caller,
     * the default behavior is to reposition the layer.
     */

  }, {
    key: "getMeetingPointClasses",
    value: function getMeetingPointClasses(contextMeetingPoint, layerMeetingPoint) {
      return classNames({
        'ContextualLayer-layer--topleft': layerMeetingPoint === 'topleft',
        'ContextualLayer-layer--top': layerMeetingPoint === 'top',
        'ContextualLayer-layer--topright': layerMeetingPoint === 'topright',
        'ContextualLayer-layer--anytop': layerMeetingPoint.includes('top'),
        'ContextualLayer-layer--right': layerMeetingPoint === 'right',
        'ContextualLayer-layer--anyright': layerMeetingPoint.includes('right'),
        'ContextualLayer-layer--bottomright': layerMeetingPoint === 'bottomright',
        'ContextualLayer-layer--bottom': layerMeetingPoint === 'bottom',
        'ContextualLayer-layer--bottomleft': layerMeetingPoint === 'bottomleft',
        'ContextualLayer-layer--anybottom': layerMeetingPoint.includes('bottom'),
        'ContextualLayer-layer--left': layerMeetingPoint === 'left',
        'ContextualLayer-layer--anyleft': layerMeetingPoint.includes('left'),
        'ContextualLayer-layer--center': layerMeetingPoint === 'center',
        'ContextualLayer-context--topleft': contextMeetingPoint === 'topleft',
        'ContextualLayer-context--top': contextMeetingPoint === 'top',
        'ContextualLayer-context--topright': contextMeetingPoint === 'topright',
        'ContextualLayer-context--anytop': contextMeetingPoint.includes('top'),
        'ContextualLayer-context--right': contextMeetingPoint === 'right',
        'ContextualLayer-context--anyright': contextMeetingPoint.includes('right'),
        'ContextualLayer-context--bottomright': contextMeetingPoint === 'bottomright',
        'ContextualLayer-context--bottom': contextMeetingPoint === 'bottom',
        'ContextualLayer-context--bottomleft': contextMeetingPoint === 'bottomleft',
        'ContextualLayer-context--anybottom': contextMeetingPoint.includes('bottom'),
        'ContextualLayer-context--left': contextMeetingPoint === 'left',
        'ContextualLayer-context--anyleft': contextMeetingPoint.includes('left'),
        'ContextualLayer-context--center': contextMeetingPoint === 'center'
      });
    }
  }, {
    key: "childStyle",
    value: function childStyle(layerMeetingPoint, contextPoint, layerRect, variableWidth) {
      var width = variableWidth ? 'auto' : "".concat(layerRect.width, "px");

      if (!contextPoint) {
        return {
          bottom: 'auto',
          left: '0px',
          right: 'auto',
          top: '0px',
          width: width
        };
      }

      var x = contextPoint.x,
          y = contextPoint.y;
      var bottom = 'auto';
      var left = "".concat(x, "px");
      var right = 'auto';
      var top = "".concat(y, "px");

      if (/bottom/.test(layerMeetingPoint)) {
        top = 'auto';
        bottom = "".concat(getViewportHeight() - y, "px");
      }

      if (/right/.test(layerMeetingPoint)) {
        left = 'auto';
        right = "".concat(getViewportWidth() - x, "px");
      }

      return {
        bottom: bottom,
        left: left,
        right: right,
        top: top,
        width: width
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          context = _this$props4.context,
          layerClassName = _this$props4.layerClassName,
          onClickOutside = _this$props4.onClickOutside,
          onMouseEnter = _this$props4.onMouseEnter,
          onMouseLeave = _this$props4.onMouseLeave,
          pointerEvents = _this$props4.pointerEvents,
          contained = _this$props4.contained,
          trapFocus = _this$props4.trapFocus,
          returnFocus = _this$props4.returnFocus,
          variableWidth = _this$props4.variableWidth;
      var _this$state = this.state,
          childStyle = _this$state.childStyle,
          contextPoint = _this$state.contextPoint,
          meetingPointClasses = _this$state.meetingPointClasses;
      var modalContentsEl = hasAncestor(context.element, 'ModalLayer-contents');
      var className = classNames(meetingPointClasses, {
        'ContextualLayer-container': true,
        'ContextualLayer--hidden': !contextPoint,
        'ContextualLayer--pointerEvents': pointerEvents,
        'ContextualLayer--inModal': modalContentsEl,
        'ContextualLayer--contained': contained
      }, layerClassName);
      return /*#__PURE__*/React.createElement(Layer, {
        onClickOutside: onClickOutside,
        onScroll: this.handleScroll,
        onResizeWindow: this.handleResizeWindow,
        trapFocus: contextPoint && !variableWidth ? trapFocus : false,
        returnFocus: returnFocus
      }, /*#__PURE__*/React.createElement("div", {
        className: className,
        ref: this.childRef,
        style: childStyle,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
      }, children));
    }
  }]);

  return ContextualLayer;
}(React.Component);

ContextualLayer.defaultProps = {
  autoflip: false,
  flipAxis: 'context-center',
  layerClassName: '',
  offsetX: 0,
  offsetY: 0,
  pointerEvents: true,
  variableWidth: false
};
export default ContextualLayer;